import type { DashboardConfigType } from '@atlassian/jira-dashboard-common/src/types.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import logger from '@atlassian/jira-common-util-logging/src/log.tsx';

const getDashboardConfig = async (id: string) => {
	try {
		return fetchJson<DashboardConfigType>(`/rest/dashboards/1.0/${id}.json`);
	} catch (error: unknown) {
		logger.unsafeErrorWithCustomerData(
			'spa-apps.dashboard.fetch-dashboard-config',
			`Failed to get dashboard config json with id=[${id}]`,
			error instanceof Error ? error : undefined,
		);
		throw error;
	}
};

export const getDashboardsConfig = async (idsCsv: string) => {
	try {
		return fetchJson<DashboardConfigType[]>(`/rest/dashboards/1.0?dashboardId=${idsCsv}`);
	} catch (error: unknown) {
		logger.unsafeErrorWithCustomerData(
			'spa-apps.dashboard.fetch-dashboard-config',
			`Failed to get dashboard config with ids=[${idsCsv}]`,
			error instanceof Error ? error : undefined,
		);
		throw error;
	}
};

export default getDashboardConfig;
